// Payer status shown to customers, payer has an issue while its monitor alerts
export enum PayerStatus {
    OPERATIONAL = "OPERATIONAL",
    ISSUE_DETECTED = "ISSUE_DETECTED",
}

export const COMMON_ONE_VERIFY_PAYER_STATUS_CONFIG = {
    // Payers incidents are returned for this period
    historyPeriodDays: 30,

    // Backend caches payer status for this long, page refreshes it as often
    refreshIntervalSeconds: 60,
}
